import React from 'react';
import HomeComponent from "./HomeComponent";
import HomeChildrenComponent from "./HomeChildrenComponent";
import HomeGipChildrenComponent from "./HomeGipChildrenComponent";

export const HomeRoot: React.FC = () => {
    return(
        <HomeComponent>
            <HomeChildrenComponent />
        </HomeComponent>
    )
};

export const HomeGip: React.FC = () => {
    return(
        <HomeComponent>
            <HomeGipChildrenComponent />
        </HomeComponent>
    )
};
